export function isAmbassadorDetailsCardEmpty() {
    return false;
}
